import axios from '@/utils/request'
// import AddProduct from '@/views/product/list/AddProduct.vue';
const base = {
  //产品管理
  projectList: "/api/goods/projectList", //产品列表
  search: "/api/goods/search", //搜索接口
  deleteItemById: "/api/goods/deleteItemById", //删除商品操作
  selectItemCategoryByParentId:"/api/goods/itemCategory/selectItemCategoryByParentId", //商品类目

  //图片上传接口
  uploadUrl: "/api/upload",
  insertTbItem: "/api/goods/item/insertTbItem", //添加商品
  batchDelete: "/api/goods/batchDelete", //批量删除
  updateTbItem: "/api/goods/item/updateTbItem", //修改商品


  // 首页配置相关接口
  getSettings: "/api/get-settings", // 获取首页配置
  saveSettings: "/api/save-settings", // 保存首页配置

  // 商品规格相关接口
  getProductsByCategory: "/api/goodsimages", //  商品规格列表
saveProjectImages: "/api/saveProjectImages",//  商品规格详情
// 添加分组
addGroupTitle: "/api/addsaveProjecttitle",
saveGroup: "/api/saveGroup",// 保存分组标题
deleteImageGroup: "/api/deleteImageGroup",// 删除分组
updateGroupImages: "/api/updateGroupImages",// 更新分组图片列表
deleteImage: "/api/deleteImage",// 删除单张图片




};
//导出方法
export default {

  /* 
    产品列表 page
  */
  projectList(params) {
    return axios.get(base.projectList, { params });
  },
  // 图片删除接口
deleteImage(imagePath) {
  return axios.post(base.deleteImage, { imagePath });
},

  /* 
    搜索接口
    params={search:xx}
  */
  search(params) {
    return axios.get(base.search, { params });
  },
  /* 
    删除操作 id
  */
  deleteItemById(params) {
    return axios.get(base.deleteItemById, { params });
  },
  /* 
    商品类目
      params={type:cid} selectItemCategoryByParentId
    */
  selectItemCategoryByParentId(params) {
    console.log('商品类目---------------');
    return axios.get(base.selectItemCategoryByParentId, { params });
  },
  /* 
    添加商品
    params={title, image, sellPoint, price, cid, category, num, descs, paramsInfo}
*/

  insertTbItem(params) {
    return axios.get(base.insertTbItem, { params });
  },
  /* 
  批量删除
    {ids:字符串--id}
  */
  batchDelete(params) {
    return axios.get(base.batchDelete, { params });
  },
  /* 
  修改商品
   params={id,title, image, sellPoint, price, cid, category, num, descs, paramsInfo}
  */
  updateTbItem(params) {
    return axios.get(base.updateTbItem, { params });
  },



  // 首页配置相关方法

  getSettings() {
    return axios.get(base.getSettings);
  },

  saveSettings(params) {
    return axios.post(base.saveSettings, params);
  },


  // 商品规格相关接口
getProductsByCategory(params) {
  return axios.get(base.getProductsByCategory, { params });
},
 saveProjectImages(params) {
    return axios.post(base.saveProjectImages, params);
  },







// 添加分组
addGroupTitle(params) {
  return axios.post(base.addGroupTitle, params);
},

// 保存分组标题
saveGroup(params) {
  return axios.post(base.saveGroup, params);
},

// 删除分组
deleteImageGroup(params) {
  return axios.post(base.deleteImageGroup, params);
},

// 更新分组图片列表
updateGroupImages(params) {
  return axios.post(base.updateGroupImages, params);
},

// 删除单张图片
deleteImage(params) {
  return axios.post(base.deleteImage, params);
},





}